import {
  DROPOFF_LOCATION_FORM_IS_VISIBLE,
  GET_FIRST_DROPOFF_SELECTION_REQUEST,
  GET_FIRST_DROPOFF_SELECTION_SUCCESS,
  SAVE_DROPOFF_SELECTION_SUCCESS,
  SET_IS_EDIT_DROPOFF_LOCATION,
  SAVE_DROPOFF_LOCATION,
  DELETE_DROPOFF_LOCATION,
  RESTORE_PICKED_LOCATION,
  RESTORE_SELECTED_LOCATION,
  SAVE_DROPOFF_DEEPLINK,
} from './dropOffLocationTypes';
import api from '../../api';
import { pick } from 'lodash';

export function setDropOffLocationFormIsVisible(isVisible) {
  return {
    type: DROPOFF_LOCATION_FORM_IS_VISIBLE,
    isVisible,
  };
}

export function getSingleHotelTable(businessId) {
  return function(dispatch, getState) {
    dispatch({ type: GET_FIRST_DROPOFF_SELECTION_REQUEST });
    const pickedDropOffLocation = [];
    api
      .get(`/drop-off-locations?business_id=${businessId}`)
      .then((responseLocation) => {
        const locationId = responseLocation.data.data[0].id;
        dispatch({
          type: GET_FIRST_DROPOFF_SELECTION_SUCCESS,
          dropOffLocations: responseLocation.data.data.length
            ? [responseLocation.data.data]
            : [],
        });
        pickedDropOffLocation.push(responseLocation.data.data[0]);
        api
          .get(`/drop-off-locations/${locationId}/options`)
          .then((responseTable) => {
            pickedDropOffLocation.push(responseTable.data.data[0]);

            dispatch({
              type: SAVE_DROPOFF_SELECTION_SUCCESS,
              dropOffLocations: pickedDropOffLocation,
              pickedDropOffLocation,
              selectedDropOffLocation: pickedDropOffLocation,
              saveDropOffLocationButtonIsEnabled: true,
            });
          });
      });
  };
}

export function getFirstDropOffSelection(businessId) {
  return function(dispatch) {
    dispatch({ type: GET_FIRST_DROPOFF_SELECTION_REQUEST });
    api
      .get(`/drop-off-locations?business_id=${businessId}`)
      .then((response) => {
        dispatch({
          type: GET_FIRST_DROPOFF_SELECTION_SUCCESS,
          dropOffLocations: response.data.data.length
            ? [response.data.data]
            : [],
        });
      });
  };
}

export function deleteDropOffLocation() {
  return {
    type: DELETE_DROPOFF_LOCATION,
    pickedDropOffLocation: [],
  };
}

export function saveDropOffLocation(location) {
  return {
    type: SAVE_DROPOFF_LOCATION,
    selectedDropOffLocation: location,
  };
}

export function setIsEditDropOffLocation(isEdit) {
  return {
    type: SET_IS_EDIT_DROPOFF_LOCATION,
    isEdit,
  };
}

export function restorePickedLocation() {
  return {
    type: RESTORE_PICKED_LOCATION,
  };
}

export function restoreSelectedLocation() {
  return function(dispatch, getState) {
    const finalDropOffLocation = getState().orderSettingReducer.dropOffDetails
      .finalDropOffLocation;
    dispatch({
      type: RESTORE_SELECTED_LOCATION,
      finalDropOffLocation: finalDropOffLocation,
    });
  };
}

export function saveDropOffSelection(location, selectionIndex) {
  let saveDropOffLocationButtonIsEnabled = false;
  return function(dispatch, getState) {
    api.get(`/drop-off-locations/${location.id}/options`).then((response) => {
      const pickedDropOffLocation = [
        ...getState().dropOffLocationReducer.pickedDropOffLocation,
      ].slice(0, selectionIndex);
      const dropOffLocations = [
        ...getState().dropOffLocationReducer.dropOffLocations,
      ].slice(0, selectionIndex + 1);
      pickedDropOffLocation[selectionIndex] = location;

      if (response.data.data.length)
        dropOffLocations[selectionIndex + 1] = response.data.data;

      if (dropOffLocations.length === pickedDropOffLocation.length) {
        saveDropOffLocationButtonIsEnabled = true;
      }

      dispatch({
        type: SAVE_DROPOFF_SELECTION_SUCCESS,
        dropOffLocations,
        pickedDropOffLocation,
        saveDropOffLocationButtonIsEnabled,
      });
    });
  };
}
export function saveDeepLinkDropOffSelection(
  deepLinkDropOffSelection,
  businessId
) {
  return async function(dispatch, getState) {
    try {
      const currentInterDropOffDetails = getState().orderSettingReducer
        .dropOffDetails;
      const [result1, result2, result3] = await Promise.all([
        api.get(`/drop-off-locations?business_id=${businessId}`),
        api.get(
          `/drop-off-locations/${deepLinkDropOffSelection.buildingId}/options`
        ),
        api.get(
          `/drop-off-locations/${deepLinkDropOffSelection.floorId}/options`
        ),
      ]);
      const buildings = result1.data.data;
      const floors = result2.data.data;
      const rooms = result3.data.data;

      const selectedBuilding = buildings.find(
        (building) => building.id === deepLinkDropOffSelection.buildingId
      );
      const selectedFloor = floors.find(
        (floor) => floor.id === deepLinkDropOffSelection.floorId
      );
      const selectedRoom = rooms.find(
        (room) => room.id === deepLinkDropOffSelection.roomId
      );

      const dropOffLocations = [buildings, floors, rooms];
      const selectedDropOff = [selectedBuilding, selectedFloor, selectedRoom];

      dispatch({
        type: SAVE_DROPOFF_DEEPLINK,
        dropOffLocations: dropOffLocations,
        savedDropOffLocations: dropOffLocations,
        selectedDropOffLocation: selectedDropOff,
        pickedDropOffLocation: selectedDropOff,
      });
      dispatch({
        type: 'UPDATE_DEEPLINK_DROPOFF_DETAILS',
        selectedDropOffLocation: selectedDropOff,
      });
    } catch (error) {}
  };
}
